import type { Workout, WorkoutSet } from "./schemas.js";

export function applyTargetRpeDefault(set: WorkoutSet): WorkoutSet {
  if (set.completed && set.rpe === null && set.targetRpe !== null) set.rpe = set.targetRpe;
  return set;
}

export function applyTargetRpeDefaults(workout: Workout): Workout {
  for (const exercise of workout.exercises) {
    for (const set of exercise.sets) applyTargetRpeDefault(set);
  }
  return workout;
}
